import { render, staticRenderFns } from "./ClearingAccount.vue?vue&type=template&id=523f1203&scoped=true"
import script from "./ClearingAccount.vue?vue&type=script&lang=js"
export * from "./ClearingAccount.vue?vue&type=script&lang=js"
import style0 from "./ClearingAccount.vue?vue&type=style&index=0&id=523f1203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f1203",
  null
  
)

export default component.exports